var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('div',{attrs:{"id":"app"},on:{"click":_vm.handleAppAction}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('dialog-manager'),_c('side-page-manager'),_c('window-resize-listener'),_c('oc-term')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }